import React from 'react';
import { MenuItemsContext } from './context';
import { IModuleManifest, INavigationMenuItem } from 'types';

interface IMenuItemsProviderProps {
    modules: IModuleManifest[];
    children?: React.ReactNode;
}

const modulesMap = (i: IModuleManifest) => i.menuItems || [];

const reduceMappedMenuItems = (prev: INavigationMenuItem[], curr: INavigationMenuItem[]) => prev.concat(curr);

export function MenuItemsProvider(props: IMenuItemsProviderProps) {
    const { children, modules } = props;
    const menuItemsInfo = React.useMemo(() => ({ menuItems: modules.map(modulesMap).reduce(reduceMappedMenuItems, []) }), [modules]);

    return (
        <MenuItemsContext.Provider value={menuItemsInfo}>
            {children}
        </MenuItemsContext.Provider>
    );
}
